<template>
  <section
    v-if="item.length"
    class="module actors"
  >
    <h3>演职人员</h3>
    <div class="actors-wrap">
      <ul class="actors-list">
        <template v-for="(i, index) in item">
          <li :key="index">
            <a
              :href="'/star?query=' + encodeURIComponent(i.star) + '&spver=' + spver"
              :uigs="'actor_' + encodeURIComponent(i.star)"
            >
              <div class="actors-item-img">
                <img v-lazy="i.image">
              </div>
              <div class="actors-item-info">
                <p class="name">{{ i.star }}</p>
                <template v-if="i.role !== ''">
                  <p
                    v-if="i.cate && i.cate === 'shengyou'"
                    class="role"
                  >配&nbsp;{{ i.role }}</p>
                  <p
                    v-else
                    class="role"
                  >饰&nbsp;{{ i.role }}</p>
                </template>
                <template v-else>
                  <p
                    v-if="i.cate && i.cate !== ''"
                    class="role"
                  >
                    {{ cate(i.cate) }}
                  </p>
                </template>
              </div>
            </a>
          </li>
        </template>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import { getSpver } from '../../common/js/util';

export default {
  name: 'Actors',
  computed: {
    ...mapState('detail', ['itemData']),
    item() {
      const ret = [];
      const lists = this.itemData.role_info;
      // 角色去重兼容
      const unionRole = {};
      if (lists && lists.length) {
        for (let i = 0; i < lists.length; i += 1) {
          const { star = '', role = '', cate = '' } = lists[i];
          if (star === '' || typeof star === 'undefined') {
            continue;
          }
          if (!unionRole[`${star}_${role}_${cate}`]) {
            unionRole[`${star}_${role}_${cate}`] = 1;
            ret.push(lists[i]);
          }
        }
      }
      return ret;
    },
    dockey() {
      return this.itemData.dockey;
    },
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'num' }) || '';
    },
  },
  methods: {
    cate(str) {
      const catemap = {
        starring: '主演',
        director: '导演',
        shengyou: '声优',
        emcee: '主持人',
        guest: '嘉宾',
      };
      const name = catemap[str];
      if (typeof name !== 'undefined') {
        return name;
      }
      return '';
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';

.actors {
  margin-bottom: 30px;
}

.actors-wrap {
  margin-top: 15px;
  height: 120px;
  overflow: hidden;
}

.actors-list {
  white-space: nowrap;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  font-size: 0;
  height: 150px;

  li {
    display: inline-block;
    margin-right: 15px;
    width: 76px;
    height: 118px;
    position: relative;
    vertical-align: top;

    &:nth-child(1) {
      margin-left: 14px;
    }
  }

  a {
    display: block;
  }

  .more {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    text-align: center;
    background: #f5f5f5;
    position: absolute;
    top: 0;
    left: 0;

    span {
      font-size: 13px;
      color: #222;
      line-height: 72px;

      &:after {
        @include arr(6px, 45deg, #555);
        content: '';
        display: inline-block;
        vertical-align: 2px;
        margin-left: 3px;
      }
    }
  }
}

.actors-item-img {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.actors-item-info {
  width: 100%;
  margin-top: 10px;

  p {
    text-align: center;
    @include line-clip(1);
  }

  .name {
    font-size: 15px;
    color: #222;
    margin-bottom: 8px;
  }

  .role {
    font-size: 13px;
    color: #999;

    span {
      margin-left: 10px;
    }
  }
}
</style>
